// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".RegularTelephone-module-control-LGdoL{display:flex;gap:var(--des-dimension-gap-and-padding-field-vertical-padding);width:100%}[dir=rtl] .RegularTelephone-module-control-LGdoL{flex-direction:row-reverse;justify-content:flex-end}.RegularTelephone-module-code-H4YYm{min-width:115px}.RegularTelephone-module-phoneSelectBlock-yYdO6{display:flex}.RegularTelephone-module-telephoneFullWidth-L9UGx{width:100%}.RegularTelephone-module-phoneContainer-HVT3G{width:100%;display:flex;flex-direction:column;align-items:flex-start;gap:var(--des-dimension-gap-and-padding-field-between-label-and-box)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"control": "RegularTelephone-module-control-LGdoL",
	"code": "RegularTelephone-module-code-H4YYm",
	"phoneSelectBlock": "RegularTelephone-module-phoneSelectBlock-yYdO6",
	"telephoneFullWidth": "RegularTelephone-module-telephoneFullWidth-L9UGx",
	"phoneContainer": "RegularTelephone-module-phoneContainer-HVT3G"
};
export default ___CSS_LOADER_EXPORT___;
